import { TRootState } from "../@types"

export const selectModalWalletBonus = ( state: TRootState ) =>state.walletBonus.walletBonusModalIsOpen

export const selectIsUpdateWalletBonus = ( state: TRootState ) =>state.walletBonus.isUpdateWalletBonus

export const selectWalletBonusForUpdate = ( state: TRootState ) =>state.walletBonus.walletBonusForUpdate

export const selectWalletBonusRefreshTable =  ( state: TRootState ) =>state.walletBonus.refreshTableWalletBonus
